import axios from 'axios'
import translate from '../utils/translations'
// import refreshAttribute from '../utils/refreshAttribute'

export default {
  name: 'newsroom',

  ui: {
    'filters[]': '[js-newsroom-filter]',
    filtersWrap: '[js-newsroom-filter-wrap]',
    cards: '[js-newsroom-cards]',
    input: '[js-newsroom-input]',
    paginationText: '[js-newsroom-pagination-text]',
    paginationButton: '[js-newsroom-pagination-button]',
    paginationBar: '[js-newsroom-pagination-bar]',
  },

  typingTimer: null,
  currentPage: 1,

  events: [
    {
      on: 'click',
      target: 'filters',
      handle ({ target }) {
        target.classList.toggle('is-active')
        this.resetParams()
        this.createLoader(this.ui.filtersWrap)
      },
    },
    {
      on: 'input',
      target: 'input',
      handle (event) {
        clearTimeout(this.typingTimer)

        this.typingTimer = setTimeout(() => {
          this.resetParams()
        }, 1000)
      },
    },
    {
      on: 'keydown',
      target: 'input',
      handle (event) {
        clearTimeout(this.typingTimer)

        if (event.keyCode === 13) {
          this.resetParams()
        }
      },
    },
  ],

  ajaxRequest () {
    const activeFilters = Array.from(document.querySelectorAll('[js-newsroom-filter].is-active')).map(filter => filter.dataset.type)

    const formData = new FormData()
    formData.append('filters', activeFilters.join('//'))
    formData.append('queryString', this.ui.input.value)
    formData.append('page', this.currentPage)
    formData.append('nonce', this.props.nonce)
    formData.append('action', this.props.action)
    formData.append('type', this.props.type)

    this.ui.cards.classList.add('is-loading')

    axios.post(this.props.url, formData)
      .then(response => {
        this.ui.cards.innerHTML = response.data.data.content
        this.totalPages = Math.ceil(response.data.data.totalCards / 9)
        this.nbCards = response.data.data.totalCards

        this.styleProgressBar()
        this.ui.cards.classList.remove('is-loading')
        this.ui.filtersWrap.classList.remove('is-loading')

        if (this.ui.paginationButton) {
          this.ui.paginationButton.classList.remove('is-loading')
        }

        if (this.el.querySelector('.loader')) this.el.querySelector('.loader').remove()
      })
      .catch(e => {
        console.log('error', e)
      })
  },

  styleProgressBar () {
    if (this.ui.paginationButton) {
      console.log(this.ui.paginationText)
      this.ui.paginationText.textContent = translate('NEWSROOM_PROGRESS').replace('*current*', this.currentPage * 9).replace('*total*', this.nbCards)

      const widthPercentage = (this.currentPage) * (100 / this.totalPages)
      this.ui.paginationBar.setAttribute('style', `width: ${widthPercentage}%;`)

      if (this.currentPage === this.totalPages) {
        this.ui.paginationText.textContent = translate('NEWSROOM_PROGRESS').replace('*current*', this.nbCards).replace('*total*', this.nbCards)
        this.ui.paginationButton.classList.add('is-hidden')
      }
    }
  },

  resetParams () {
    this.currentPage = 1
    this.ajaxRequest()

    if (this.ui.paginationButton) {
      this.ui.paginationButton.classList.remove('is-hidden')
    }
  },

  componentDidMount () {
    this.totalPages = Math.ceil(this.props.nbCards / 9)
    this.nbCards = this.props.nbCards
    this.styleProgressBar()

    // not always present so can't be put in events
    if (this.ui.paginationButton) {
      this.ui.paginationButton.addEventListener('click', () => {
        this.currentPage = this.currentPage + 1
        this.ajaxRequest()

        this.createLoader(this.ui.paginationButton)
      })
    }
  },

  createLoader (container) {
    const loader = document.createElement('div')
    loader.classList.add('loader')
    container.prepend(loader)
    container.classList.add('is-loading')
  },
}
